// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13yhL","top":"styles_top__GEFzd"};